import { render, staticRenderFns } from "./RelatoriosAtividades.vue?vue&type=template&id=8475f14e"
import script from "./RelatoriosAtividades.vue?vue&type=script&lang=js"
export * from "./RelatoriosAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports